export default function(argument1, argument2, options) {
    return (argument1 === argument2) ? options.fn(this) : options.inverse(this);
}
